import React, { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { concatWithDot } from '../../../../../../../helpers/string';
import { TextInputControl } from '../../../../../../_basic/Form/TextInput';
import { ISectionRowProps as IProps } from '../../../../../interface';
import { KEY_FEATURES_NAMES } from '../../utils/form';

import scssVariables from 'styles/sass-variables.module.scss';

export const KeyFeaturesRow: FC<IProps> = memo(({ name, disabled = false }) => {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const id = concatWithDot(name, KEY_FEATURES_NAMES.FEATURE);

  return (
    <Grid
      container
      item
      sx={{ background: scssVariables.greys_background, borderRadius: '8px', padding: '16px', gap: '16px' }}
    >
      <Grid item xs={12}>
        <TextInputControl control={control} id={id} name={id} disabled={disabled} label={t('keyFeature')} maxLength={100}/>
      </Grid>
      <Grid item xs={12}>
        <TextInputControl
          control={control}
          id={id}
          name={concatWithDot(name, KEY_FEATURES_NAMES.DESCRIPTION)}
          disabled={disabled}
          label={t('description')}
          maxLength={500}
          multiline
          hiddenLabel
        />
      </Grid>
    </Grid>
  );
});
